enum LookupMethod {
    Lookup = 'Lookup',
     Indexed = 'Indexed',
}

export default LookupMethod;